webpackJsonp([6],{

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLanding_vue__ = __webpack_require__(240);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd57e972_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLanding_vue__ = __webpack_require__(254);
function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var normalizeComponent = __webpack_require__(27)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd57e972"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLanding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd57e972_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLanding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppLanding',
  created: function created() {
    if (this.$auth.ready() && this.$auth.check()) {
      this.$router.push('/dashboard');
    }
  }
});

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(253);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(205)("0fcc9199", content, true, {});

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(204)(true);
// imports


// module
exports.push([module.i, ".landing-container[data-v-bd57e972]{font-size:1.3em;padding:4em 1em 1em;max-width:700px;overflow:auto;margin:0 auto;display:grid;grid-gap:3em;-webkit-box-align:start;-ms-flex-align:start;align-items:start;justify-items:start;-ms-flex-line-pack:start;align-content:start}.landing-container ul[data-v-bd57e972]{list-style:none;justify-self:center;grid-gap:2em;justify-items:center;grid-template-columns:1fr 1fr}.landing-container a[data-v-bd57e972],.landing-container ul[data-v-bd57e972]{display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.landing-container a[data-v-bd57e972]{background-color:var(--primary-colour);color:#fff;font-weight:700;padding:.7em 1.5em;border-radius:100px;grid-gap:1em;grid-template-columns:auto 1fr}.landing-container a[data-v-bd57e972]:hover{background-color:var(--primary-colour-hover);-webkit-transition:all .4s;transition:all .4s}.landing-container a:hover i[data-v-bd57e972]{color:rgba(0,0,0,.4)}@media (max-width:400px){.landing-container ul[data-v-bd57e972]{grid-template-columns:1fr}}", "", {"version":3,"sources":["/home/forge/slidekick.daniel-waghorn.com/src/components/AppLanding.vue"],"names":[],"mappings":"AACA,oCACE,gBAAiB,AACjB,oBAAyB,AACzB,gBAAiB,AACjB,cAAe,AACf,cAAe,AAEf,aAAc,AACd,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,kBAAmB,AAC3B,oBAAqB,AACrB,yBAA0B,AACtB,mBAAqB,CAC1B,AACD,uCACE,gBAAiB,AACjB,oBAAqB,AAGrB,aAAc,AAId,qBAAsB,AACtB,6BAA+B,CAChC,AACD,6EARE,aAAc,AAEd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAgB7B,AAZD,sCACE,uCAAwC,AACxC,WAAa,AACb,gBAAkB,AAClB,mBAAqB,AACrB,oBAAqB,AAErB,aAAc,AACd,8BAAgC,CAIjC,AACD,4CACE,6CAA8C,AAC9C,2BAA6B,AAC7B,kBAAqB,CACtB,AACD,8CACE,oBAA0B,CAC3B,AACD,yBACA,uCACI,yBAA2B,CAC9B,CACA","file":"AppLanding.vue","sourcesContent":["\n.landing-container[data-v-bd57e972] {\n  font-size: 1.3em;\n  padding: 4em 1em 1em 1em;\n  max-width: 700px;\n  overflow: auto;\n  margin: 0 auto;\n    \n  display: grid;\n  grid-gap: 3em;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: start;\n  justify-items: start;\n  -ms-flex-line-pack: start;\n      align-content: start;\n}\n.landing-container ul[data-v-bd57e972] {\n  list-style: none;\n  justify-self: center;\n\n  display: grid;\n  grid-gap: 2em;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  justify-items: center;\n  grid-template-columns: 1fr 1fr;\n}\n.landing-container a[data-v-bd57e972] {\n  background-color: var(--primary-colour);\n  color: white;\n  font-weight: bold;\n  padding: 0.7em 1.5em;\n  border-radius: 100px;\n  display: grid;\n  grid-gap: 1em;\n  grid-template-columns: auto 1fr;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.landing-container a[data-v-bd57e972]:hover {\n  background-color: var(--primary-colour-hover);\n  -webkit-transition: 0.4s all;\n  transition: 0.4s all;\n}\n.landing-container a:hover i[data-v-bd57e972] {\n  color: rgba(0, 0, 0, 0.4);\n}\n@media (max-width: 400px) {\n.landing-container ul[data-v-bd57e972] {\n    grid-template-columns: 1fr;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-container"},[_c('h1',[_vm._v("Welcome to Slidekick!")]),_vm._v(" "),_c('p',[_vm._v("\n    Slidekick is a web application for composing and presenting slides, with real-time collaboration tools.\n  ")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: 'auth.login' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("lock")]),_vm._v(" "),_c('span',[_vm._v("Log In")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'auth.register' }}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")]),_vm._v(" "),_c('span',[_vm._v("Register")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.804c6475e853e665af90.js